import React, { useState, useEffect } from "react";
import {
  IoIosArrowForward,
  IoIosArrowBack,
  IoIosArrowRoundForward,
} from "react-icons/io";
import RedRose from "../assets/images/Slider images/landscape_Mix Rose bonquet.jpeg";
import MixRose from "../assets/images/Slider images/landscape_Pink rose bonquet.jpeg";
import BigRose from "../assets/images/Slider images/landscape_Red and pink rose bonquet.jpeg";
import RedBigRose from "../assets/images/Slider images/landscape_Red rose big bonquet.jpeg";
import "./HomePage.css";
import { Link } from "react-router-dom";

import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

export default function HomePage() {
  const [visibleProducts, setVisibleProducts] = useState(6);
  const sliderImages = [RedRose, MixRose, BigRose,RedBigRose];
  const [currentSlider, setCurrentSlider] = useState(0);
  const [products, setProducts] = useState([]);

  /* ---------------- SLIDER ---------------- */

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlider((prev) => (prev + 1) % sliderImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [sliderImages.length]);

  const prevSlide = () => {
    setCurrentSlider((prev) =>
      prev === 0 ? sliderImages.length - 1 : prev - 1,
    );
  };

  const nextSlide = () => {
    setCurrentSlider((prev) => (prev + 1) % sliderImages.length);
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 600) {
        setVisibleProducts(2);
      } else if (width <= 1024) {
        setVisibleProducts(4);
      } else {
        setVisibleProducts(7);
      }
    };

    handleResize(); // important

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /* ---------------- FIREBASE PRODUCTS ---------------- */

  useEffect(() => {
    const fetchProducts = async () => {
      const querySnapshot = await getDocs(collection(db, "products"));

      const productArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setProducts(productArray);
    };

    fetchProducts();
  }, []);

  /* ---------------- UI ---------------- */

  return (
    <section className="home-container">
      {/* IMAGE SLIDER */}
      <aside className="home-image-slider">
        <div className="home-left-slider" onClick={prevSlide}>
          <IoIosArrowBack />
        </div>

        <div className="home-sliding-images">
          <img src={sliderImages[currentSlider]} alt="bouquet" />
        </div>

        <div className="home-right-slider" onClick={nextSlide}>
          <IoIosArrowForward />
        </div>
      </aside>

      {/* CATEGORY MENU */}
      <aside className="home-category-options">
        <Link to="/category/all" className="category all">
          All
        </Link>
        <Link to="/category/garland" className="category garland">
          Garland
        </Link>
        <Link to="/category/bouquet" className="category bouquet">
          Bouquet
        </Link>
        <Link to="/category/weddingGarland" className="category weddingGarland">
          Wedding Garland
        </Link>
        <Link to="/category/carGarland" className="category carGarland">
          Car Garland
        </Link>
        <Link to="/category/carDecoration" className="category carDecoration">
          Car Decoration
        </Link>
        <Link
          to="/category/flowerAccessories"
          className="category flowerAccessories"
        >
          Flower Accessories
        </Link>
      </aside>

      {/* PRODUCTS */}
      <aside className="home-products">
        <article className="home-products-display">
          {products.slice(0, visibleProducts).map((v) => {
            const image = v.images && v.images.length > 0 ? v.images[0] : "";

            return (
              <Link
                to={`/product/${v.id}`}
                className="home-product-data"
                key={v.id}
              >
                <div className="home-product-image">
                  <img src={image} alt={v.name} />
                </div>

                <div className="home-product-name">{v.name}</div>

                <div className="home-product-price">
                  ₹{v.price}
                  <span className="home-oldprice">₹{v.oldprice}</span>
                </div>
              </Link>
            );
          })}
        </article>

        {/* EXPLORE MORE */}
        <article className="more">
          <Link to="/category/all">
            Explore More <IoIosArrowRoundForward />
          </Link>
        </article>
      </aside>
    </section>
  );
}
